module.exports = __webpack_public_path__ + "static/img/2_1_1.2f5be96d.png";